import { createRouter } from './app/routes';

import { ToastContainer } from '@amigoapp/doca-react';
import moment from 'moment';
import { RouterProvider } from 'react-router-dom';

import 'moment/locale/pt-br';

moment.locale('pt-br');

moment.defineLocale('pt-br', {
	months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
	weekdaysMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S']
});

const TOAST_OPTIONS = {
	autoClose: 5000,
	closeOnClick: true,
	draggable: true,
	hideProgressBar: true,
	newestOnTop: false,
	pauseOnFocusLoss: true,
	pauseOnHover: true,
	position: 'top-center',
	rtl: false
};

function App() {
	const router = createRouter();

	return (
		<>
			<ToastContainer {...TOAST_OPTIONS} />
			<RouterProvider router={router} />
		</>
	);
}

export default App;
